import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ChevronRight } from '@leroy-merlin-br/backyard-react-icons'

import node from '../../utils/prop-types'
import * as S from './styled'

const Item = ({ node, isLastItem }) => {
  const categoryId = node.id || null

  const renderContent = () => {
    if (isLastItem) {
      return (
        <S.Title size="kilo" noMargin>
          {node.name}
        </S.Title>
      )
    }

    return (
      <Fragment>
        <a href={node.url}>
          <S.Title size="kilo" noMargin>
            {node.name}
          </S.Title>
        </a>
        <S.SeparatorIcon as={ChevronRight} size="byte" />
      </Fragment>
    )
  }

  return <S.Item data-category-id={categoryId}>{renderContent()}</S.Item>
}

Item.propTypes = {
  node: PropTypes.shape({ ...node }).isRequired,
  isLastItem: PropTypes.bool.isRequired
}

export default Item
